<template>
  <div
    class="r-select common-flex common-justify-between"
    :style="{ width: width + 'px' }"
  >
    <div class="title">
      {{ config.label }}<span v-if="config.must" style="color: red">*</span>
    </div>
    <Select
      filterable
      :not-found-text="$t('noDate')"
      v-model="config.value"
      :disabled="disabled"
      @on-change="changeSelect"
      placeholder=""
      style="width: 170px"
    >
      <Option v-for="item in config.list" :value="item.id" :key="item.id">{{
        item.name
      }}</Option>
    </Select>
  </div>
</template>

<script>
export default {
  name: "r-select",
  data() {
    return {};
  },
  /*label 标题
    must 是否必填,
    type 类型,
    value select选中项,
    list: select列表 */
  props: {
    config: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    width: {
      type: [Number, String],
      default: 350,
    },
    index: Number, //索引
  },
  methods: {
    changeSelect() {
      this.$emit("changeSelect", this.index);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.r-select {
  // width: 350px;
  padding-bottom: 2px;
  border-bottom: 0.5px solid #666666;
  .title {
    // width: 170px;
    flex-basis: 50%;
  }
  input {
    width: 170px;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/r-select.vue